import { Tooltip } from '@mui/material';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { IronDomeContext } from '../context';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

type Props = {
  onSelectOfferDone: (selectedOffers: any[]) => void;
  hasSelection?: boolean;
};

const IronDomeMemberSelector: React.FC<Props> = ({ onSelectOfferDone, hasSelection }) => {
  const [selectedOffers, setSelectedOffers] = useState<any[]>([]);
  const { offers, searchOffers, focusOfferId } = useContext(IronDomeContext);
  const gridApiRef = useRef<any>(null);
  const focusAppliedRef = useRef(false);

  const onRowDataUpdated = (event: any) => {
    if (!focusOfferId || focusAppliedRef.current) return;

    event.api.forEachNode((node: any) => {
      if (node.data?._id !== focusOfferId) return;
      focusAppliedRef.current = true;
      node.setSelected(true);
      event.api.ensureNodeVisible(node, 'top');
    });
  };

  useEffect(() => {
    if (gridApiRef.current) {
      const selectedIds = selectedOffers.map((offer) => offer._id);
      gridApiRef.current.api.forEachNode((node: any) => {
        if (selectedIds.includes(node.data._id)) {
          node.setSelected(true);
        }
      });
    }
  }, [offers]);

  const onFilterChanged = () => {
    const filterModel = gridApiRef.current?.api?.getFilterModel();
    const name = filterModel?.name?.filter ?? '';
    searchOffers(name);
  };

  const columnDefs = [
    {
      headerName: '',
      field: 'blockRules',
      width:50,
      cellRenderer: (params: any) => {
        const hasBlockRules = params.data?.blockRules?.length > 0;
        return (
          <Tooltip title={hasBlockRules ? 'Has block rules' : 'No block rules'}>
            <span
              style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: hasBlockRules ? '#4CAF50' : '#F44336'
              }}
            />
          </Tooltip>
        );
      },
      sortable: false,
      filter: false,
      headerTooltip: 'Block Rules Indicator',
    },
    {
      headerName: 'Name',
      field: 'name',
      checkboxSelection: true,
      flex: 1,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
  ];

  const onSelectionChanged = (event: any) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node: any) => node.data);
    onSelectOfferDone(selectedData);
    setSelectedOffers(selectedData);
  };

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: hasSelection ? '300px' : '800px', width: '100%' }}
    >
      <AgGridReact
        columnDefs={columnDefs}
        rowData={offers}
        rowSelection="multiple"
        onSelectionChanged={onSelectionChanged}
        onFilterChanged={onFilterChanged}
        onRowDataUpdated={onRowDataUpdated}
        onGridReady={(params) => {
          gridApiRef.current = params;
        }}
      />
    </div>
  );
};

export default IronDomeMemberSelector;
